import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, FormControl, FormControlLabel, Checkbox } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ChevronLeft, User } from 'react-feather';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Toastmessage from '../../components/Toast';
import { logout } from '../../features/auth/AuthSlice';
import { authApi } from '../../api/api';

export default function ViewSubscription() {
    const [rows, setRows] = useState([]);
    const [modules, setModules] = useState([]); // State to store fetched modules
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userID = useSelector((state) => state.auth.id);
    const token = useSelector((state) => state.auth.token);
    const { subscriptionsId } = location.state || {};

    const [formData, setFormData] = useState({
        subscription_name: "",
        price: [{ month: null, actual_price: "", discount_price: "" }],
        access_modules: [],
        status: false,
    });

    useEffect(() => {
        if (subscriptionsId) {
            viewSubscription(subscriptionsId);
        }
    }, [subscriptionsId]);

    useEffect(() => {
        // Transform `formData.price` into table rows
        const transformedRows = formData.price.map((item, index) => ({
            id: index + 1, // Use index as a unique ID
            month: item.month,
            actualprice: item.actual_price,
            saleprice: item.discount_price,
        }));
        setRows(transformedRows);
        fetchModule();
    }, [formData.price]);

    // Define fetchModule separately to reuse it
    const fetchModule = async () => {
        const input_token = 'MODULES'; // Replace with your actual token
        const apiUrl = 'list_of_modules'; // Replace with the actual API endpoint

        const dataInput = {
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);
            

            if (data && data.success) {
            // Set filtered rows to the same data initially
            setModules(data.access_modules);
            } else if (data && data.message === 'Token has expired') {
            dispatch(logout());
            localStorage.removeItem('token');
            await Toastmessage('Session expired. Redirecting to login...', false);
            navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }
            
        } catch (error) {
        console.error("Error fetching data:", error);
        if (error.response && error.response.status === 401) {
            dispatch(logout());
            localStorage.removeItem('token');
            await Toastmessage('Session expired. Redirecting to login...', false);
            navigate('/login');
        } else {
            await Toastmessage('Something went wrong', false);
        }
        }
    }

    const columns = [
        { field: 'month', headerName: 'Month' },
        { field: 'actualprice', headerName: 'Actual Price' },
        { field: 'saleprice', headerName: 'Sale Price' },
    ];

    const handleClickEdit = () => {
        navigate('/editsubscriptions', { state: { subscriptionsId } });
    };

    const handleBack = () => {
        setTimeout(() => navigate('/subscriptions'));
    };

    const viewSubscription = async (subscriptionsId) => {
        const input_token = subscriptionsId + 'VIEW_SUBS';
        const apiUrl = 'view_subscription';

        const dataInput = {
            id: subscriptionsId,
            login_user_id: userID,
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);
            if (data && data.data) {
                const {
                    subscription_id,
                    subscription_name,
                    price,
                    access_modules,
                    status
                } = data.data;

                setFormData({
                    id: subscription_id,
                    login_user_id: userID,
                    subscription_name: subscription_name || "",
                    price: price || [{ month: null, actual_price: "", discount_price: "" }],
                    access_modules: access_modules || [],
                    status: status
                });
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    return (
        <Box>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
            >
                {/* Left Section */}
                <Box display="flex" alignItems="center">
                    <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={12} color="var(--text-color)">
                    Subscription View
                    </Typography>
                </Box>

                {/* Right Section */}
                <Button
                    variant="outlined"
                    component={Link}
                    to="/subscriptions"
                    sx={{
                        backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '10px 20px'
                    }}
                    startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
                    style={{ textTransform: 'none' }}
                >
                    Back to Subscriptions list
                </Button>
            </Box>

          <Box className="card-box" sx={{ p: { xs: 2, sm: 2, md: 3 }, m: { xs: 1, sm: 2, md: 3 }, border: '1px solid var(--border-color)', borderRadius: '8px' }}>
            
            <Box className="sub-header">
                <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                    Subscription View
                </Typography>
                <Typography sx={{ fontWeight: 'bold' }}>
                    Account status:{" "}
                    <span style={{ color: formData.status ? 'green' : 'red', fontWeight: 'bold' }}>
                        {formData.status ? 'Active' : 'Inactive'}
                    </span>
                </Typography>
            </Box>

            <Box>
                <Grid container spacing={6}>
                    <Grid size={3}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>
                            Subscription Name:
                        </Typography>
                        <Typography sx={{ fontSize: '16px', color: '#595A63' }}>
                            {formData.subscription_name}
                        </Typography>
                    </Grid>
                    <Grid size={5}>
                    <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>
                            Subscription Plan:
                        </Typography>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr>
                                    {columns.map((col) => (
                                        <th
                                            key={col.field}
                                            style={{
                                                border: '1px solid var(--table-border-color)',
                                                padding: '8px',
                                                backgroundColor: 'var(--sub-header-bg)',
                                                textAlign: 'left',
                                                color:"var(--text-color)"
                                            }}
                                        >
                                            {col.headerName}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row) => (
                                    <tr key={row.id}>
                                        {columns.map((col) => (
                                            <td
                                                key={col.field}
                                                style={{
                                                    border: '1px solid var(--table-border-color)',
                                                    padding: '8px',
                                                    color:'var(--lable-color)'
                                                }}
                                            >
                                                {row[col.field]}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Grid>
                    <Grid size={4}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>
                            Subscription Modules:
                        </Typography>
                        <FormControl>
                            {modules.map((module) => (
                                <FormControlLabel
                                    key={module.id}
                                    control={
                                        <Checkbox
                                            checked={formData.access_modules.includes(module.id)}
                                            disabled
                                            sx={{
                                                transform: "scale(0.7)",
                                                borderRadius: "8px",
                                                padding: "2px",
                                                "&.Mui-checked": {
                                                    color: "#3570FF",
                                                },
                                            }}
                                        />
                                    }
                                    label={module.module_name}
                                    sx={{
                                        marginBottom: 3,
                                        color: "#8A8A8A",
                                    }}
                                />
                            ))}
                            
                        </FormControl>
                    </Grid>
                </Grid>

                <Box display="flex" justifyContent="center" gap={2} mt={4}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleClickEdit}
                        sx={{
                            padding: '15px 30px',
                            borderRadius: '8px',
                            fontWeight: 'bold',
                            backgroundColor: 'var(--primary-color)',
                            color: '#fff',
                            '&:hover': { backgroundColor: 'var(--primary-color)' },
                        }}
                    >
                        Edit Subscription Details
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={handleBack}
                        sx={{
                            padding: '15px 30px',
                            borderRadius: '8px',
                            fontWeight: 'bold',
                            backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                            '&:hover': { backgroundColor: 'var(--primary-color)', color: '#fff' },
                        }}
                    >
                        <ChevronLeft size={24} /> Back to Subscription list
                    </Button>
                </Box>
            </Box>
        </Box>
        </Box>
       
    );
}
